/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { MaterialIcon, AlertBar } from '@blend/enterprise-components';
import { notaryAPI } from '../api/notary';
import { Dispatch } from '../redux';

export function fetchRoomDetail(roomId: string) {
  return async (dispatch: Dispatch) => {
    const room = await notaryAPI.rooms.fetchRoomDetail(roomId);
    dispatch({
      type: 'SET_ROOM_DETAIL',
      payload: room,
    });
  };
}

export function resetRoomDetail() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'SET_ROOM_DETAIL',
      payload: null,
    });
  };
}

export function fetchParticipants(roomId: string) {
  return async (dispatch: Dispatch) => {
    const participants = await notaryAPI.rooms.fetchParticipantsInRoom(roomId);
    dispatch({
      type: 'SET_PARTICIPANTS',
      payload: participants,
    });
  };
}

export function resetParticipants() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'SET_PARTICIPANTS',
      payload: [],
    });
  };
}

export function setRoomError(error: {
  hasError: boolean;
  message?: string;
  theme?: AlertBar.Props['theme'];
  icon?: MaterialIcon.Props['type'];
  canCancel?: boolean;
}) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: 'SET_ROOM_ERROR',
      payload: error,
    });
  };
}

export function fetchRoomMetadata(roomId: string) {
  return async (dispatch: Dispatch) => {
    const metadata = await notaryAPI.rooms.fetchRoomMetadata(roomId);
    dispatch({
      type: 'SET_ROOM_METADATA',
      payload: metadata,
    });
  };
}

export function fetchRoomNotes(roomId: string) {
  return async (dispatch: Dispatch) => {
    const notes = await notaryAPI.rooms.fetchRoomNotes(roomId);
    dispatch({
      type: 'SET_ROOM_NOTES',
      payload: notes,
    });
  };
}

export function fetchRoomNotaryTasks(roomId: string) {
  return async (dispatch: Dispatch) => {
    const notaryTasks = await notaryAPI.rooms.fetchRoomNotaryTasks(roomId);
    dispatch({
      type: 'SET_ROOM_NOTARY_TASKS',
      payload: notaryTasks,
    });
  };
}
